module.exports = __webpack_public_path__ + "static/media/Japan_manufacturing_business_guide_wbn_b2b_export_suppliers.cf0783b9.svg";